import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Button, Overlay } from 'react-bootstrap';
import { LabelWithArrow } from './basic';
import { CheckBox } from './forms';
import '../../public/less/multiSelect.less';

var SelectedElement = React.createClass({
    render() {
        var onClick = function () {
            this
                .props
                .Remove(this.props.Item);
        }
        return (
            <label className='SelectedElement'><div onClick={onClick.bind(this)} />{this.props.Item.value}</label>
        )
    }
});

var SelectedElementsContainer = React.createClass({
    render() {
        var removeItemFunc = this.props.RemoveItem;
        var lines = this
            .props
            .Items
            .map(function (item, i) {
                return (<SelectedElement Remove={removeItemFunc} key={i} Item={item} />);

            });
        return (
            <div className='MultiSelectSelected'>
                {lines}
            </div>
        );
    }
});

var ListItem = React.createClass({
    render() {
        var item = this.props.item;

        var checkBoxClick = function (id, isChecked) {
            item.markItemInParent(item);

            this
                .props
                .onChange(id, isChecked);
        }

        var isChecked = false;
        if (typeof (item.isChecked) === "function") {
            var isChecked = item.isChecked(item.id);
        }
        else if (item.isChecked) {
            isChecked = item.isChecked;
        }

        return (
            <span>
                <CheckBox
                    onChange={checkBoxClick.bind(this)}
                    id={item.id}
                    isChecked={isChecked}>{item.value}</CheckBox>
            </span>
        );
    }
});

const CustomPopover = React.createClass({
    render() {
        var lines = this
            .props
            .Items
            .map(function (item, i) {
                return (<ListItem item={item} key={i} onChange={item.onChange} />);
            });
        return (
            <div className='dropDownPopover'>
                {lines}
            </div>
        );
    }
});

module.exports = class DropDown extends Component {
    constructor(props) {
        super(props);

        this.valuesWithProp = [];
        for (var i in this.props.Data) {
            var isChecked = this.props.Data[i].isChecked ? this.props.Data[i].isChecked : false;
            this
                .valuesWithProp
                .push({
                    isChecked: isChecked,
                    value: this.props.Data[i].name,
                    id: this.props.Data[i].id,
                    markItemInParent: this
                        .markItem
                        .bind(this),
                    onChange: this.props.onChange
                });
        }

        this.state = {
            show: false,
            SelectedOptions: [],
            data: this.valuesWithProp
        }
    };


    resetSelected() {
        this.setState({ SelectedOptions: [] });

        var items = this.state.data;
        for (var i = 0; i < items.length; i++)
        {
            if (items[i].isChecked) {
                this.removeItem(items[i]);
            }
        }
    }


    markItem(item) {
        if (!item.isChecked) {
            item.isChecked = true;
            var currentItems = this.state.SelectedOptions;
            currentItems.push(item)
            this.setState({ SelectedOptions: currentItems });
        } else {
            item.isChecked = false;
            this.removeItem(item);
        }
    };

    removeItem(removedItem) {
        removedItem.isChecked = false;
        var currentItems = this.state.SelectedOptions;
        var removedIndex = currentItems.indexOf(removedItem);
        if (removedIndex > -1) {
            currentItems.splice(removedIndex, 1);
            this.setState({ SelectedOptions: currentItems })
        }

    };

    show(val) {
        if (val != undefined && typeof (val) === "boolean") {
            this.setState({ show: val });
        } else {
            var show = this.state.show;
            this.setState({
                show: !show
            });
        }
    };

    render() {
        return (
            <div className='multiSelect'>
                <div className='multiSelectTrigger'>
                    <label
                        className='h5'
                        ref="target"
                        onClick={this
                            .show
                            .bind(this)}><LabelWithArrow Label={this.props.Label} /></label>

                    <Overlay
                        show={this.state.show}
                        animation={false}
                        onHide={() => this.setState({ show: false })}
                        placement="bottom"
                        container={this}
                        rootClose={true}
                        target={() => ReactDOM.findDOMNode(this.refs.target)}>
                        <CustomPopover Items={this.state.data} onChange={this.props.onChange} />
                    </Overlay>
                </div>

            </div>
        )
    }
};



// WEBPACK FOOTER //
// ./modules/common/dropDown.jsx